export enum NameCurrentWebApp{
    ProcessStart,
    FetchFromGit,
    StopIISSite,
    NpmRunBuild,
    FolderClear,
    FolderCopy,
    StartIISSite
}